import { render, staticRenderFns } from "./MyApi.vue?vue&type=template&id=73734ae7&scoped=true"
import script from "./MyApi.vue?vue&type=script&lang=js"
export * from "./MyApi.vue?vue&type=script&lang=js"
import style0 from "./MyApi.vue?vue&type=style&index=0&id=73734ae7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73734ae7",
  null
  
)

export default component.exports